// Build-time nonce for Emotion style tags (react-select), generated fresh
// per build in gatsby-config.js and exposed here as a GATSBY_-prefixed env
// var so this module (bundled into the client) sees the same value the
// style-src CSP directive was generated with for that build.
export const CSP_STYLE_NONCE = process.env.GATSBY_CSP_STYLE_NONCE
